export function stripTrailingSlash(str: string) {
    return str.replace(/\/$/, "");
}
